import React from 'react'

export default function Box4() {
    return (
        <div className='w-100 col-4'>
             <div className="custom-roadmap-box-container p-3 rounded-3">
                      <h1>Enhanced User Experience Features</h1>
                      <hr/>
                      <p>We focused on improving user experience by integrating enhanced features and functionalities, making our software more intuitive and user-friendly.</p>
                      
                    </div>
        </div>
      )
}
